import PeopleScreen from './PeopleScreen'
export default PeopleScreen
